export default __webpack_public_path__ + "static/media/product_4.39098797.webp";